import { Refusals, refusalReason } from "./refusalMessageKey";

const phone = (name: string) => `phoneValidation.${name}`;

/** What a visitor is told when an SMS code is refused, on the sign-up and the signing pages alike. */
export const PHONE_CODE_REFUSALS: Refusals = {
  "429": "customRegistration.page.toast.tooManyAttempts",
  CODE_INCORRECT: phone("codeIncorrect"),
  CODE_EXPIRED: phone("codeExpired"),
  CODE_ATTEMPTS_EXCEEDED: phone("codeAttemptsExceeded"),
  CODE_NOT_PENDING: phone("codeNotPending"),
  PHONE_CHANGED: phone("phoneChanged"),
  REGION_NOT_SERVED: phone("regionNotServed"),
  NO_SMS_CREDIT: phone("noSmsCredit"),
  ALREADY_VALIDATED: phone("alreadyValidated"),
  CODE_ALREADY_SENT: phone("codeAlreadySent"),
};

const CODE_SPENT_REASONS = [
  "CODE_ATTEMPTS_EXCEEDED",
  "CODE_EXPIRED",
  "CODE_NOT_PENDING",
  "PHONE_CHANGED",
];

/** Whether the refused code can no longer be used, so only a new code helps. */
export const isCodeSpent = (error: unknown) =>
  CODE_SPENT_REASONS.includes(refusalReason(error) ?? "");

/** The values a refusal message may show, such as the seconds before a new code. */
export const refusalValues = (error: any) => ({
  seconds: error?.response?.data?.element?.retry_after_seconds,
});
